(ns teamoesterreich.admin-mode.event.event-sort-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.event :as d-events]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.edit :refer [edit]]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [reagent-material-ui.icons.add :refer [add]]
            [teamoesterreich.admin-mode.static-data :as staticData]))


(defonce EVENT_CATEGORY_CLASSIC "EINSATZ")


(defn org-renderer [dep-mask-list dst-mask-list]
  ;(js/console.log "org-renderer " (clj->js dep-mask-list) (clj->js dst-mask-list))
  (fn [js-parm]
    (let [{orgId "cellData"} (js->clj js-parm)
          depId (d-organisation/get-first-dep (keys dep-mask-list) orgId)
          ]
      ;(js/console.log l-date)
      (r/as-element
        [:span (or (get dep-mask-list depId) "") " / " (or (get dst-mask-list orgId) "")]))))

(defn date-renderer [js-parm]
  (let [{cellData "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (if (> (count cellData) 10) (h/date-time-ger-fromT cellData) "-")])))

(defn status-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (or (get staticData/EVENT_STATUS_MAP cell-data) (str "? " cell-data))])))

(defn edit-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)
          event (get-in @!st [:data cell-data])]
      (r/as-element
        [mui/icon-button {:label   "bearbeiten"
                          :onClick #(a/open-event-view event)
                          } [edit {:fontSize "small"}]]))))



(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !show-inactive (r/cursor !st [:show-inactive])

          !organisations (r/cursor v-state/app-state [:organisations])
          dep-mask-list (reduce (fn [c [k v]] (assoc c k v)) {} (or (d-organisation/get-lv-filter-list @!organisations) []))
          dst-mask-list (reduce (fn [c [k v]] (assoc c k v)) {} (or (d-organisation/get-dest-list @!organisations) []))
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "EventList"}
         (log/debug "rerender " m " @!show-inactive " @!show-inactive " @!sort " @!sort " @!reverse " @!reverse (count rows))

         [:> rv/Column
          {:label     "Nummer"
           :dataKey   (name :crowdtaskerEvent-toeEventId)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     120}]
         [:> rv/Column
          {:label        "Status"
           :dataKey      (name :crowdtaskerEvent-status)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer status-renderer
           :width        100}]


         [:> rv/Column
          {:label        "Verb / Dst"
           :dataKey      (name :crowdtaskerEvent-orgId)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer (org-renderer dep-mask-list dst-mask-list)
           :width        200}]

         [:> rv/Column
          {:label     "EinsatzTyp"
           :dataKey   (name :crowdtaskerEvent-category)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     170}]
         [:> rv/Column
          {:label     "EinsatzName"
           :dataKey   (name :crowdtaskerEvent-name)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left" :color "blue"}
           :width     270}]
         [:> rv/Column
          {:label        "Zusage bis"
           :dataKey      (name :crowdtaskerEvent-acceptableUntil)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer date-renderer
           :width        120}]
         [:> rv/Column
          {:label        "Start"
           :dataKey      (name :crowdtaskerEvent-timeFrom)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer date-renderer
           :width        120}]
         [:> rv/Column
          {:label        "Ende"
           :dataKey      (name :crowdtaskerEvent-timeTo)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer date-renderer
           :width        120}]
         [:> rv/Column
          {:label     "Eingeladen"
           :dataKey   (name :_crowdtaskerEvent-countMembers)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     120}]
         [:> rv/Column
          {:label        "#"
           :dataKey      (name :crowdtaskerEvent-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !st)
           :width        70}]

         ]))))


(defn sort-filter-fn [data show-inactive search org-filter sort_ reverse_]
  (log/debug "filter-fn " (count data) " s:" search " i:" show-inactive " of:" org-filter "[ " sort_ reverse_ "]")
  (let [sort_ (or sort_ :crowdtaskerEvent-timeFrom)
        reverse_ (if (nil? reverse_) true reverse_)
        rows (filter (fn [[k e]]
                       (and
                         true
                         (or show-inactive (not= (:crowdtaskerEvent-status e) "finished"))
                         (org-selector/check-org-id (:crowdtaskerEvent-orgId e) org-filter)
                         (not= (:crowdtaskerEvent-category e) "ONLINE")
                         (re-find
                           (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
                           (str (:crowdtaskerEvent-toeEventId e) "#" (:crowdtaskerEvent-name e)))
                         ))
                     data)

        rows (sort-by (fn [e] (get e (keyword sort_))) (map second rows))

        rows (if reverse_ (reverse rows) rows)

        ]
    rows))

(defn update-list [!st]
  (let [!data (r/cursor !st [:data])
        !loaded? (r/cursor !st [:loaded])
        !search (r/cursor !st [:search])
        !org-filter (r/cursor !st [:org-filter])
        !show-inactive (r/cursor !st [:show-inactive])
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        ]
    ;(js/console.log "update-list " @!loaded? @!show-inactive @!search @!sort @!reverse)
    (if-not @!loaded?
      (d-events/get-event-list-elements
        (fn [data]
          (let [r-data (sort-filter-fn data @!show-inactive (str @!search) @!org-filter @!sort @!reverse)]
            (swap! !st assoc
                   :data data
                   :loaded true
                   :count (count r-data)
                   :rows r-data)))
        )
      (let [r-data (sort-filter-fn @!data @!show-inactive (str @!search) @!org-filter @!sort @!reverse)]
        (swap! !st assoc
               :count (count r-data)
               :rows r-data))
      )))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (js/console.log "Mount toe-event-map ")
  (let [!st (r/cursor v-state/app-state [:event :event-list-state])
        !create-modal (r/cursor !st [:create-modal])
        !show-inactive (r/cursor !st [:show-inactive])
        !org-filter (r/cursor !st [:org-filter])
        !loaded? (r/cursor !st [:loaded])
        !rows (r/cursor !st [:rows])
        ]
    (update-list !st)
    (if (not @!loaded?)
      (do [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])
      [mui/paper
       [create-with-name-modal/modal
        !create-modal
        "Bitte gib einen Namen für den neuen Einsatz ein"
        "Erstellen"
        (fn [name]
          (log/debug "Create news with Name: " name)
          (d-events/>new-classic-event name (fn [new]
                                              (log/debug "Created event : " new)
                                              (reset! !loaded? false)
                                              (swap! v-state/app-state assoc
                                                     :selected-event new
                                                     :site :event-overview
                                                     )
                                              ))
          )
        ]
       [mui/grid
        {:container  true
         :direction  "row"
         :alignItems "stretch"
         :justify    "flex-start"
         :spacing    1
         :style      {:marginTop "15px" :height "100%" :minHeight "400px"}
         }

        [mui/grid
         {:item true
          :md   2
          :xs   3
          }
         [mui/button {:startIcon (r/as-element [add]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                      :onClick   #(reset! !create-modal true)
                      }
          "Neuer Einsatz"]
         ]

        [mui/grid
         {:item true
          :md   8
          :xs   6
          :type {:textAlign "bottom"}
          }
         [mui/typography {:variant "h5" :padding "5px 0 0 0"}
          " Einsatz-Liste "]]

        [mui/grid
         {:item true
          :md   2
          :xs   3
          }
         [ws-event-sync-component/ws-event-reload !loaded? :crowdtasker-event_off] ;; too many updates
         ]

        ;; LINE
        ;
        ;
        [mui/grid
         {:item true
          :lg   5
          :md   7
          :xs   8
          }
         [org-selector/get-selector !org-filter (fn []) (d-rights/get-rights-orgId-filter d-rights/CLASSIC)]
         ]

        [mui/grid
         {:item true
          :lg   4
          :md   2
          :xs   0
          }]

        [mui/grid
         {:item true
          :lg   3
          :md   3
          :xs   4
          }
         [mui/radio-group {:row true :class "filterRadio" :style {:marginLeft "15px"}}
          [mui/form-control-label {:label   "Nicht aktive einblenden" :value "dst" :placement "start"
                                   :control (r/as-element [mui/checkbox {:checked  (or @!show-inactive false)
                                                                         :onChange (fn [_ val] (reset! !show-inactive val))
                                                                         }])}]]]


        [mui/grid
         {:item true
          :xs   12
          }
         [get-table !st !rows]
         ]
        ]

       ]))
  )